import { render, staticRenderFns } from "./ATKWUWRF.vue?vue&type=template&id=0906cb6b&scoped=true&"
import script from "./ATKWUWRF.vue?vue&type=script&lang=js&"
export * from "./ATKWUWRF.vue?vue&type=script&lang=js&"
import style0 from "./ATKWUWRF.vue?vue&type=style&index=0&id=0906cb6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906cb6b",
  null
  
)

export default component.exports